document.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-khoja-sizechart-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('data-khoja-sizechart-open'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closer = event.target.closest('[data-khoja-sizechart-close]');
  if (closer) {
    const dialog = closer.closest('dialog');
    if (dialog) dialog.close();
    return;
  }

  const dialogEl = event.target.closest('dialog.khoja-sizechart-dialog');
  if (dialogEl && event.target === dialogEl) {
    dialogEl.close();
    return;
  }

  const tabButton = event.target.closest('[data-khoja-tab]');
  if (tabButton) {
    const dialog = tabButton.closest('.khoja-sizechart-dialog');
    if (!dialog) return;
    const target = tabButton.getAttribute('data-khoja-tab');
    dialog.querySelectorAll('[data-khoja-tab]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === tabButton);
    });
    dialog.querySelectorAll('[data-khoja-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-khoja-panel') !== target;
    });
    return;
  }

  const unitButton = event.target.closest('[data-khoja-unit]');
  if (unitButton) {
    const dialog = unitButton.closest('.khoja-sizechart-dialog');
    if (!dialog) return;
    const targetUnit = unitButton.getAttribute('data-khoja-unit');
    dialog.querySelectorAll('[data-khoja-unit]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === unitButton);
    });
    const table = dialog.querySelector('.khoja-sizechart-table');
    const defaultUnit = table.getAttribute('data-khoja-unit-default') || 'in';
    table.querySelectorAll('td[data-khoja-value]').forEach(function (cell) {
      const raw = parseFloat(cell.getAttribute('data-khoja-value'));
      if (isNaN(raw)) return;
      if (targetUnit === defaultUnit) {
        cell.textContent = cell.getAttribute('data-khoja-value');
      } else if (targetUnit === 'cm') {
        cell.textContent = (raw * 2.54).toFixed(1);
      } else {
        cell.textContent = (raw / 2.54).toFixed(1);
      }
    });
    const unitLabel = dialog.querySelector('[data-khoja-find-unit-label]');
    if (unitLabel) unitLabel.textContent = targetUnit;
    return;
  }

  const findBtn = event.target.closest('[data-khoja-find-size]');
  if (findBtn) {
    const dialog = findBtn.closest('.khoja-sizechart-dialog');
    if (!dialog) return;
    const inputs = Array.prototype.slice.call(dialog.querySelectorAll('[data-khoja-find-input]'));
    const resultEl = dialog.querySelector('[data-khoja-find-result]');
    const activeUnitBtn = dialog.querySelector('[data-khoja-unit].is-active');
    const activeUnit = activeUnitBtn ? activeUnitBtn.getAttribute('data-khoja-unit') : 'in';
    const table = dialog.querySelector('.khoja-sizechart-table');
    const defaultUnit = table.getAttribute('data-khoja-unit-default') || 'in';

    const entries = [];
    inputs.forEach(function (input) {
      const val = parseFloat(input.value);
      if (isNaN(val) || val <= 0) return;
      let valInDefaultUnit = val;
      if (activeUnit !== defaultUnit) {
        valInDefaultUnit = activeUnit === 'cm' ? val / 2.54 : val * 2.54;
      }
      entries.push({ colIndex: parseInt(input.getAttribute('data-khoja-find-col'), 10), value: valInDefaultUnit });
    });

    if (entries.length === 0) {
      resultEl.textContent = 'Enter at least one measurement to see your size.';
      resultEl.classList.remove('is-success');
      return;
    }

    const rows = table.querySelectorAll('tbody tr');
    let best = null;
    rows.forEach(function (row) {
      const sizeLabel = row.querySelector('th').textContent.trim();
      const cells = row.querySelectorAll('td[data-khoja-value]');
      let total = 0;
      let count = 0;
      entries.forEach(function (entry) {
        const cell = cells[entry.colIndex];
        if (!cell) return;
        const raw = parseFloat(cell.getAttribute('data-khoja-value'));
        if (isNaN(raw)) return;
        total += Math.abs(raw - entry.value);
        count++;
      });
      if (count === 0) return;
      const avgDiff = total / count;
      if (!best || avgDiff < best.avgDiff) {
        best = { size: sizeLabel, avgDiff: avgDiff };
      }
    });

    rows.forEach(function (row) {
      row.classList.remove('is-recommended');
    });

    if (best) {
      rows.forEach(function (row) {
        if (row.querySelector('th').textContent.trim() === best.size) row.classList.add('is-recommended');
      });
      const measureWord = entries.length === 1 ? 'measurement' : 'measurements';
      resultEl.innerHTML =
        'Based on ' +
        entries.length +
        ' ' +
        measureWord +
        ', your closest match is <strong>' +
        best.size +
        '</strong>. Between sizes? Size up for a relaxed fit, down for a closer one.';
      resultEl.classList.add('is-success');
    } else {
      resultEl.textContent = "We couldn't match that — try the size chart instead.";
      resultEl.classList.remove('is-success');
    }
    return;
  }
});
